import { DeepReadonly, IUniversityKey } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const universityKeys: DeepReadonly<IUniversityKey[]> = deepFreeze([
  { key: 'UoG', name: 'University of Greenwich' },
  { key: 'USW', name: 'University of South Wales' },
  { key: 'ARU', name: 'Anglia Ruskin University' },
  { key: 'BCU', name: 'Birmingham City University' },
  { key: 'STR', name: 'University of Strathclyde' },
]);

export const SHARE_CODE_EXPIRY_DAYS_DEFAULT = 90;
export const SHARE_CODE_EXPIRY_ALERT_DAYS_DEFAULT = 14;

export * from './offices.js';
